import { onBeforeUnmount as u, createElementBlock as p, openBlock as m } from "vue";
import d from "lodash/merge";
import { useToast as f } from "vue-toastification";
import { Hub as _ } from "aws-amplify/utils";
const b = { id: "toastMessages" }, A = {
  __name: "ToastMessages",
  props: {
    extend: {
      required: !1,
      type: Function,
      default: () => {
      }
    }
  },
  setup(r) {
    const c = r, i = _.listen("toast", (o) => {
      const { event: t, data: s, message: a } = o.payload, e = d(
        {},
        {
          content: a ?? "",
          type: t,
          draggable: !1,
          position: "top-center",
          timeout: 1e4,
          accessibility: {
            toastRole: t === "error" ? "alert" : "status"
          }
        },
        s || {},
        c.extend(t, a, s) || {}
      ), { content: l } = e;
      delete e.content;
      const n = f();
      switch (t) {
        case "clearAll":
          n.clear();
          break;
        default:
          n(l, e);
      }
    });
    return u(() => {
      i();
    }), (o, t) => (m(), p("div", b));
  }
};
export {
  A as _
};
